/**
 * Prefix constant used when creating admin panel action creators.
 */
export const ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX = 'admin_panels/';
